

import History from "./History.vue";
import CurrentReading from "./CurrentRead.vue";
import GoalHistory from "./currentGoal.vue";
import UserNav from './Nav'
import { mapGetters } from "vuex";
export default {
  name: "ReaderPage",
  components: {
    UserNav,
    History,
    CurrentReading,
    GoalHistory
  },
  data() {
    return {
      query: "",
      displayModal: false,
      modal1: false,
    };
  },
  computed: {
    ...mapGetters(["getUserGoals", "getUserBooks"]),
  },
  async mounted() {},
  methods: {
    search() {
      this.searchBooks(this.query);
    },
    clearOutput() {
      if (!this.query) {
        this.clearSearchOutput();
      }
    },
    async getSuggestions() {
      if (!this.query) {
        this.fetchSearchSuggestions([]);
        return;
      }
      try {
        const searchBookResults = await this.fetchSearchSuggestions(this.query);
        this.fetchSearchSuggestions(this.searchBookResults);
      } catch (error) {
        console.error(error);
      }
    },
  },
};
